import { Avatar, Badge, List, ListItem, ListItemAvatar, ListItemText, useTheme } from '@mui/material';
import moment from 'moment';
import route from '../../Router';
import DataListView, { getId } from '../../components/data/DataListView';
import { BaseDataTable, ColumnData, DataTableProps, NoDataPaper, NoDataText } from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { ViewMode } from '../../components/data/ViewModes';
import Logo from '../../icons/Logo';
import { Notification } from '../../models/Types';
import { NotificationForm, notificationParse } from './NotificationForm';
import { TopAppBar } from '../../nav/AppBar';
import { TopBarBreadcrumbs } from '../../components/data/DataBreadcrumbs';
import { getUser } from '../../models/Identity';
import Proxy from '../../models/Proxy';
import FaviconAvatar from '../../icons/Favicon';

const columns: ColumnData<Notification>[] = [{
    label: 'Заголовок',
    name: 'Name',
    filter: true,
    routerLink: true
}, {
    label: 'Дата',
    name: 'CreateDate',
    type: 'date',
    filter: true
}];

class NotificationTable extends BaseDataTable<Notification>{

    public getData() {
        return super.getData()?.sort((a, b) => b.CreateDate.getTime() - a.CreateDate.getTime());
    }

    public applyData(data?: Notification[]) {
        var result = super.applyData(data);

        if (data) {
            var user = getUser();
            var lnid = user.LastReadNotificationId;
            var cid = Math.max(...data.map(x => x.Id));
            if (cid > lnid) {
                Proxy.post('NotificationRead', cid).then(() => user.LastReadNotificationId = cid);
            }
        }

        return result;
    }

    renderTable() {
        var lnid = getUser().LastReadNotificationId;
        return <List sx={{ m: 0, p: 0 }}>
            {this.getData().map((row, i) =><ListItem key={i}>
                <ListItemAvatar>
                    {lnid < row.Id ? <Badge color="error" variant="dot" overlap="circular">
                        <FaviconAvatar size={48} />
                    </Badge> : <FaviconAvatar size={48} />}
                </ListItemAvatar>
                <ListItemText
                    primaryTypographyProps={{ variant: 'menu' }}
                    primary={row.Name}
                    secondaryTypographyProps={{ variant: 'body3', mt: 1.5 }}
                    secondary={moment(row.CreateDate).calendar()} />
            </ListItem>)}
        </List>;
    }
}

function ThemedTable(props: DataTableProps<Notification>) {
    const theme = useTheme();
    return <NotificationTable {...props} theme={theme} />;
}

export class NotificationListView extends DataListView<Notification>{
    protected renderTable(props: DataTableProps<Notification>, mode?: ViewMode<Notification>) {
        return <ThemedTable {...props} />;
    }

    buildBody() {
        return <>
            <TopAppBar left={<TopBarBreadcrumbs title="Главная" needBack={true} />} right={<></>} />
            {this.buildTopToolbar()}

            {this.buildView() }
        </>;
    }

    render() {
        if (getId(this.props) >= 0 && !route.get('hideForm')) {
            return <></>;
        } else {
            return super.render();
        }
    }
}

export default function NotificationView() {
    return <DataView<Notification>
        title="Уведомление"
        titleMultiple="Уведомления"
        typeId="Notification"
        modes={[{ mode: 'list', hideAddBtn: true }]}
        form={(id, apiRef) => <NotificationForm key="main" id={id} apiRef={apiRef} />}
        canEdit={false}
        listView={(props, setListApi) => <NotificationListView {...props} apiRef={setListApi} />}
        tableProps={{
            columns, dataParser: notificationParse, noDataRenderer: () => <NoDataText>Новые уведомления отсутствуют</NoDataText> }} />;
}